import actions from './actions';
import mutations from './mutations';
import {groupSpider} from '../util';

const strategyModule = {
    namespaced: true,
    actions,
    mutations,
    state: {
        codes: [], //标签
        marks: [],
        codesRequestError: false,
        codesFirstLoad: true,
        codesLoading: false,
        marksRequestError: false,
        marksFirstLoad: true,
        marksLoading: false
    },
    getters: {
        codesMap: state => {
            const { codes } = state;
            const codesMap = {};
            codes.forEach(tag => {
                codesMap[tag.code] = tag.text;
            });
            return codesMap;
        },
        markList: state => {
            const { marks } = state;
            return groupSpider(marks);
        },
        marksMap: state => {
            const { marks } = state;
            const marksMap = {};
            marks.forEach(item => {
                marksMap[item.mark] = item.code;
            })
            return marksMap;
        }
        
    }
}

export default strategyModule;